import { Lightning } from '@lightningjs/sdk';
import _merge from 'lodash/merge';
import Icon from '../icon/icon.component';
import {
  getInitialStyle,
  defaultContext,
  unFocusedStyle,
  getIconViewBox,
  getFocusedStyle,
  MOSAIC_CARD_SIZE,
} from './mosaicCard.style';
import { SELECTED_SIGNAL } from '../signals';
import FocusShader from '../shaders/focus.shader';
import { cover } from '../utils/textures';

/**
 * The mosaic is an entry by theme, by channel or by setting
 *
 * @version 1.3.0
 * @see https://zeroheight.com/726d5c282/p/38523e-mosaic-tv--v130/b/402201
 */
export class MosaicCard extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {
          rect: true,
          shader: {
            type: FocusShader,
          },
        },
        Background: {
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Image: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Content: {
          IconWrapper: {
            Icon: {
              type: Icon,
            },
          },
          Label: {},
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _detach() {
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  set item(value) {
    this._item = value;
    const { image } = this._item;
    const imageUrl = (image && image.src) || '';

    this.tag('Icon').once('txLoaded', () => {
      this.tag('Icon').setSmooth('alpha', 1);
    });

    this.patch({
      Image: {
        texture:
          imageUrl && imageUrl.length
            ? cover(imageUrl, MOSAIC_CARD_SIZE[this._style.screenSize].w, MOSAIC_CARD_SIZE[this._style.screenSize].h)
            : null,
      },
      Content: {
        Label: {
          text: {
            text: value.label || '',
          },
        },
        IconWrapper: {
          Icon: {
            alpha: 0.0001,
            iconData: {
              picto: value.picto,
              viewBox: getIconViewBox(this._style.screenSize),
            },
          },
        },
      },
    });
  }

  _focus() {
    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this.patch(unFocusedStyle);
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._item);

    return true;
  }
}
